import React, { useState } from 'react';
import Header from './components/Header';
import UploadForm from './components/UploadForm';
import Report from './components/Report';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:4000';

function App() {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (saeFile, vbFile, facturaFile, consecutivo) => {
    setLoading(true);
    setError(null);
    setReport(null);

    const formData = new FormData();
    formData.append('sae', saeFile);
    if (vbFile) formData.append('vistoBueno', vbFile);
    if (facturaFile) formData.append('facturaExportacion', facturaFile);
    if (consecutivo) formData.append('consecutivo', consecutivo);

    try {
      const res = await axios.post(`${API}/api/validate`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000,
      });
      setReport(res.data);
    } catch (err) {
      const msg = err.response?.data?.error || err.message;
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    if (!report) return;
    try {
      const res = await axios.post(`${API}/api/validate/export/excel`, report, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Validacion_SAE_AURUM.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Error exportando Excel: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleExportPDF = async () => {
    if (!report) return;
    try {
      const res = await axios.post(`${API}/api/validate/export/pdf`, report, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Validacion_SAE_AURUM.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Error exportando PDF: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleReset = () => {
    setReport(null);
    setError(null);
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-5xl mx-auto px-6 py-8">
        {!report ? (
          <>
            <UploadForm onSubmit={handleSubmit} loading={loading} />
            {error && (
              <div className="mt-6 bg-red-50 border border-red-300 rounded-lg p-4 text-red-700">
                <p className="font-semibold">Error</p>
                <p className="mt-1 text-sm">{error}</p>
              </div>
            )}
          </>
        ) : (
          <Report
            report={report}
            onExportExcel={handleExportExcel}
            onExportPDF={handleExportPDF}
            onReset={handleReset}
          />
        )}
      </main>
      <footer className="text-center text-gray-400 text-xs py-4 border-t">
        Revisión de Solicitud de Autorización de Embarque © {new Date().getFullYear()}
      </footer>
    </div>
  );
}

export default App;
